import script from "./Recruits.vue?vue&type=script&setup=true&lang=js"
export * from "./Recruits.vue?vue&type=script&setup=true&lang=js"

import "./Recruits.vue?vue&type=style&index=0&id=68a0eacf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a0eacf"]])

export default __exports__